.xm-file-drop-zone {
  position: relative;

  &-overlay {
    position: absolute;
    inset: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 16px;
    text-align: center;
    border: 2px dashed var(--xm-color-highlight);
    border-radius: 8px;
    background: color-mix(in srgb, var(--xm-bg-secondary) 85%, transparent);
    backdrop-filter: blur(2px);
    pointer-events: none;
    animation: xm-file-drop-zone-fade-in 0.15s ease-out;
  }

  &-icon {
    margin-bottom: 8px;
    font-size: 40px;
    color: var(--xm-color-highlight);
  }

  &-title.ant-typography {
    margin: 0;
    color: var(--xm-color-highlight);
  }
}

@keyframes xm-file-drop-zone-fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
